import { useMemo } from 'react';
import { getLogisticsOrderDetailsItemsColumns } from './columns';
import { ILogisticsOrderDetailsItemsDatagridProps } from '../../../types/commonDatagrid';
import { CompactPhoneDatagrid } from '../CompactPhoneDatagrid.tsx';
import { Typography } from '@mui/material';

export const LogisticsOrderDetailsDatagridItems = ({
  data,
}: ILogisticsOrderDetailsItemsDatagridProps) => {
  const columns = useMemo(() => {
    return getLogisticsOrderDetailsItemsColumns();
  }, []);

  const subtotal = data
    .reduce((sum: number, row: { total: string }) => sum + Number(row.total || 0), 0)
    .toFixed(2);

  return (
    <>
      <CompactPhoneDatagrid
        data={data}
        columns={columns}
        rowId={'sku'}
        footer={
          <>
            <Typography fontSize={12}>Subtotal</Typography>
            <Typography fontSize={12} fontWeight={600}>
              ${subtotal}
            </Typography>
          </>
        }
      />
    </>
  );
};
